<script setup>
import ImagemNadaEcontrado from '@/assets/there_is_nothing_here.svg';
const props = defineProps({
    mensagem: String
})

</script>

<template>
    <div class="flex  flex-column align-items-center  gap-5">
        <img :src="ImagemNadaEcontrado"
            class="w-20rem md:w-25rem" />
        <div class="text-2xl text-color text-center">{{ props.mensagem }}
        </div>
    </div>

</template>